import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import Tabs from "./Tabs";
import ReactGA from "react-ga4";

function CommitteeDetails({ type, legislatureOrdinal }) {
  const { id } = useParams();
  const [committeeData, setCommitteeData] = useState(null);
  const [additionalTabs, setAdditionalTabs] = useState([]);
  const [enabledTabs, setEnabledTabs] = useState([]);
  const [isCommitteeOfWhole, setIsCommitteeOfWhole] = useState(false);
  const [govdeliveryLink, setGovdeliveryLink] = useState("");
  const [allMeetings, setAllMeetings] = useState([]);
  const [upcomingMeetings, setUpcomingMeetings] = useState([]);
  const [legislativeCalendarDays, setLegislativeCalendarDays] = useState([]);

  useEffect(() => {
    const fetchCommitteeData = async () => {
      try {
        let apiUrl = "";
        if (type === "standing") {
          apiUrl = `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommittees/${id}`;
        } else if (type === "nonStanding") {
          apiUrl = `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/nonStandingCommittees/${id}`;
        }

        const response = await axios.get(apiUrl);
        if (
          response.data.committeeDetails.committeeCode.code === "CWH" ||
          response.data.committeeDetails.committeeCode.code === "CWS"
        ) {
          const { data } = await axios.get(
            `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/legislativeCalendarDays/findBySessionId?sessionId=${response.data.sessionId}`
          );

          setLegislativeCalendarDays(data);
        }
        setCommitteeData(response.data);
      } catch (error) {
        console.error("Error fetching committee data:", error);
      }
    };

    const fetchAdditionalTabs = async () => {
      const tryFetch = async (apiType) => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_WP_HOST}/wp-json/legmt/v1/committees/search?committeesEntity=${apiType}&lawsId=${id}`
          );
          return response.data;
        } catch (error) {
          console.warn(`Failed to fetch tabs for type "${apiType}"`, error);
          return null;
        }
      };

      let data;
      if(!(type === "StandingCommittee" || type === "NonStandingCommittee"))
        data = await tryFetch(type === "standing" ? "StandingCommittee" : "NonStandingCommittee");
      else
        data = await tryFetch(type);

      if (data) {
        const tabs = data?.tabs || [];
        const enabled = data?.enabledTabs || [];
        setAdditionalTabs(
          tabs.map((tab) => ({
            title: tab.tabTitle,
            content: tab.sections.map(section => {
              return {
                sectionTitle: section.sectionTitle,
                sectionContent: section.layouts.map(layout => layout.content)
              }
            })
          }))
        );
        setEnabledTabs(enabled);
        setIsCommitteeOfWhole(data.isCommitteeOfTheWhole)
      } else {
        setAdditionalTabs([]);
        setEnabledTabs([]);
      }
    };
    
    ReactGA.event({
      category: "View Type",
      action: `${type}-${id} clicked`,
      label: `${type}-${id} clicked`,
    });

    fetchCommitteeData();
    fetchAdditionalTabs();
  }, [id, type]);

  if (!committeeData) return <p>Loading...</p>;

  const { committeeDetails, chamber } = committeeData;
  const { committeeCode } = committeeDetails || {};
  const { description } = committeeCode?.committeeType || {};

  return (
    <>
      <MDBContainer fluid>
        <h5 className="mb-0 sub-heading">
          {type === "standing"
            ? `${chamber || ""} ${description || "Committee"}`
            : description || "Committee"}
        </h5>
        <h1 className="mb-4 title">
          {committeeCode?.name || "Committee"} ({committeeCode?.code || ""})
        </h1>
          <MDBRow>
            <MDBCol lg="12" className="mt-1">
              <Tabs
                additionalTabs={additionalTabs}
                type={type}
                enabledTabs={enabledTabs}
                id={id}
                legislatureOrdinal={legislatureOrdinal}
                committeeData={committeeData}
                name={committeeCode.name}
                allMeetings={allMeetings}
                key={allMeetings.length}
                showOnlyMeetings={isCommitteeOfWhole}
                legislativeCalendarDays={legislativeCalendarDays}
                committeeCode={committeeCode}
              />
            </MDBCol>
          </MDBRow>
      </MDBContainer>
    </>
  );
}

export default CommitteeDetails;
